import { useSelector } from 'react-redux';

const defaultPatientProfileSettings = {
  actionBarGroup: {
    showEditButton: true,
    showMhrSyncingButton: true,
    showPatientAssignButton: false,
    showReviewTriggerButton: false,
    showReconciliationSummary: false,
    showMedicationProfileButton: false,
  },
  taskBar: {
    showTask: false,
  },
  themeStyle: '',
};
export const usePatientProfileSettings = () => {
  const { features: patientTenancyFeatures } = useSelector(
    (state) => state.patientProfile,
  );

  return (
    patientTenancyFeatures?.patientProfileSettings ??
    defaultPatientProfileSettings
  );
};
